module.exports = __webpack_public_path__ + "ef910875ebbeedd232640487ee1e42e6.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/icons/linecons/linecons.ttf?28801370
// module id = 451
// module chunks = 0